import {
  AnaliticalMixing,
  GrainMixCalc,
  Home,
  ManageGrainWarehouse,
  Mixing,
  MixingSimple,
  Prices,
} from '@ui/icons';

export const APP_SECTIONS = [
  {
    shortTitle: 'Склады',
    title: 'Управление зерновыми складами',
    description: 'В этом разделе вы можете вести учёт зерновых активов',
    link: '/storage',
    icon: Home,
    icon2: ManageGrainWarehouse,
  },
  {
    shortTitle: 'Миксование',
    title: 'Аналитическое миксование',
    description:
      'В этом разделе вы сможете увеличить стоимость складских зерновых активов, применяя метод миксования зерна',
    link: '/mixing',
    icon: Mixing,
    icon2: AnaliticalMixing,
  },
  // {
  //   shortTitle: 'Консервация',
  //   title: 'Консервация зерновых культур',
  //   description: '',
  //   link: '/conservation',
  //   icon: ConservationIcon,
  // },
  // {
  // shortTitle: 'Цены',
  //   title: 'Стоимость складских зерновых активов',
  //   description:
  //     'В этом разделе вы сможете видеть стоимость складских зерновых активов, на основании рыночных цен',
  //   link: '/prices',
  //   icon: Prices,
  // },
  {
    shortTitle: 'Бункер-перегрузчик',
    title: 'Калькулятор простых зерновых миксов',
    description:
      'В этом разделе вы сможете рассчитать выгоду от мискования зерна разных классов',
    link: '/mixing-simple',
    icon: MixingSimple,
    icon2: GrainMixCalc,
  },
];
